import { Gender } from '../../types'
import type { UserId } from '../users/types'

export type ProfileId = number

export enum UrgentRelationship {
  SPOUSE = '配偶者',
  FAMILY = '家族・親族',
  WORKPLACE = '勤務先',
  OTHER = 'その他',
}

export interface Profile {
  id: ProfileId
  userId: UserId
  name: string
  firstName: string
  lastName: string
  nameKana: string
  firstNameKana: string
  lastNameKana: string
  email: string
  nationality: string | null
  sex: Gender
  birthday: string
  postalCode: string
  prefecture: string
  address1: string
  address2: string
  tel: string
  urgentTel: string
  urgentRelationship: UrgentRelationship
}

export interface UpdateProfileParams {
  firstName: string
  firstNameKana: string
  lastName: string
  lastNameKana: string
  nationality: string
  sex: string
  birthday: string
  tel: string
  urgentTel: string
  urgentRelationship: string // UrgentRelationship
  postalCode: string
  prefecture: string
  address1: string
  address2: string
}

export interface EmailDeliveryResponse {
  campaign: 0 | 1
  newPrograms: 0 | 1
  featureUpdates: 0 | 1
}

export interface EmailDeliveryOptions {
  campaign: boolean
  newPrograms: boolean
  featureUpdates: boolean
}

export interface RequestEmailChangeParams {
  newEmail: string
  currentPassword: string
}
